// frontend/src/components/quran/QcfFontFace.jsx
//
// Load font QCF V2 per halaman pakai FontFace API langsung (bukan inject
// <style> @font-face + document.fonts.load(), yang ternyata bisa
// nganggep "selesai" padahal font belum bener-bener siap). FontFace API
// cuma resolve kalau font-nya beneran berhasil di-fetch & di-parse, dan
// reject kalau beneran gagal — jadi onReady(true) baru dipanggil kalau
// semua font kebutuhan halaman ini beneran siap dipakai.

import { useEffect, useRef } from "react";

const loadedFamilies = new Set(); // font-family yang sudah terdaftar di document.fonts

const loadOnePage = async (page) => {
  const fontFamily = `qcf-page-${page}`;
  console.log(`QCF_DEBUG: loadOnePage(${page}), sudah loaded?`, loadedFamilies.has(fontFamily));
  if (loadedFamilies.has(fontFamily)) return;

  const attempt = async () => {
    console.log(`QCF_DEBUG: mencoba fetch /qcf-v2/fonts/p${page}.woff2`);
    const face = new FontFace(fontFamily, `url(/qcf-v2/fonts/p${page}.woff2)`);
    await face.load();
    document.fonts.add(face);
    loadedFamilies.add(fontFamily);
    console.log(`QCF_DEBUG: SUKSES load font halaman ${page}, total document.fonts.size =`, document.fonts.size);
  };

  try {
    await attempt();
  } catch (err) {
    console.error(`QCF: gagal load font halaman ${page}, retry...`, err);
    try {
      await attempt();
    } catch (err2) {
      console.error(`QCF: retry gagal untuk halaman ${page}, lanjut pakai fallback font.`, err2);
      // Sengaja tidak throw lagi — biar Promise.all di bawah tetap selesai
      // dan UI nggak stuck skeleton selamanya. Ayat akan tampil pakai
      // font fallback ('Amiri', serif) untuk halaman ini saja.
    }
  }
};

/**
 * @param {number[]} pageNumbers - daftar nomor halaman (1-604) yang perlu di-load fontnya
 * @param {(ready: boolean) => void} onReady - dipanggil false saat mulai load, true saat semua font selesai dicoba (sukses atau gagal-lalu-fallback)
 */
const QcfFontFace = ({ pageNumbers = [], onReady }) => {
  console.log("QCF_DEBUG: QcfFontFace render dengan pageNumbers =", pageNumbers);
  const key = pageNumbers.join(",");
  const lastKeyRef = useRef(null);

  useEffect(() => {
    console.log("QCF_DEBUG: useEffect jalan, key =", key, "lastKey =", lastKeyRef.current);
    if (lastKeyRef.current === key) return;
    lastKeyRef.current = key;

    let cancelled = false;
    onReady?.(false);

    const validPages = pageNumbers.filter(Boolean);
    if (validPages.length === 0) {
      console.log("QCF_DEBUG: validPages kosong, langsung onReady(true)");
      onReady?.(true);
      return;
    }

    console.log("QCF_DEBUG: mulai load font untuk halaman:", validPages);
    Promise.all(validPages.map(loadOnePage)).then(() => {
      console.log("QCF_DEBUG: semua font selesai dicoba, cancelled =", cancelled);
      if (!cancelled) onReady?.(true);
    });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return null;
};

export default QcfFontFace;
